import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

export const ErrorState = ({ error, onRetry }) => {
  return (
    <Alert severity="error" sx={{ mb: 4, p: 3 }}>
      <MDBox display="flex" alignItems="center" justifyContent="space-between">
        <MDTypography variant="body1" component="span" sx={{ flex: 1, mr: 2 }}>
          {error}
        </MDTypography>
        <MDButton 
          onClick={onRetry} 
          color="info" 
          variant="outlined" 
          size="medium"
          sx={{ 
            minWidth: 100,
            borderRadius: '20px',
            px: 3
          }}
        >
          Retry
        </MDButton>
      </MDBox>
    </Alert>
  );
};

ErrorState.propTypes = {
  error: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
}; 